import React, { useEffect } from 'react';
import { MapPin } from 'lucide-react';
import { Card, CardBody, Badge, Container, Row, Col } from 'reactstrap';

export default function ZoneStatus({ zoneWiseAlerts }) {
  const staticZones = [
    { id: 'C', name: 'Zone C', cameras: 15, alerts: 'N/A', priority: 'medium', highlighted: false },
  ];

  const zones = zoneWiseAlerts?.map((zone, index) => ({
    id: zone.zone_id,
    name: zone.zone_name,
    cameras: Math.floor(Math.random() * 10) + 5,
    alerts: zone.alert_count,
    priority: zone.alert_count > 3 ? 'high' : 'medium', // Dynamic priority
    highlighted: zone.alert_count > 3 // Highlight if alert_count is high
  })) || staticZones;


  const getZoneCardStyle = (highlighted) => ({
    border: highlighted ? '1.5px solid #e53e3e' : '1px solid #e2e8f0',
    backgroundColor: highlighted ? '#fff5f5' : '#ffffff',
    borderRadius: '12px',
    boxShadow: 'none',
    marginBottom: "12px"
  });

  const getPriorityStyle = (priority) => ({
    fontSize: '13px',
    padding: '4px 12px',
    backgroundColor: priority === 'high' ? '#2b6cb0' : '#edf2f7',
    color: priority === 'high' ? '#ffffff' : '#2d3748',
    borderRadius: '999px',
    textTransform: 'lowercase',
    fontWeight: 500
  });


  useEffect(() => {
    console.log(zoneWiseAlerts)
    console.log(zoneWiseAlerts)
  }, [zoneWiseAlerts])

  return (

    <Card style={{
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      padding: '20px',
      border: 'none',
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",

    }}>
      <CardBody className="p-0">
        {/* Header */}
        <Row className="align-items-center mb-3">
          <Col>
            <h2 style={{
              fontSize: '28px',
              fontWeight: 700,
              color: '#1a237e',
              marginBottom: 0
            }}>
              Zone Status
            </h2>
          </Col>
          <Col xs="auto">
            <div style={{
              backgroundColor: "#FFFFFF",
              padding: "5px 16px",
              borderRadius: "20px",
              fontSize: "14px",
              fontWeight: "500",
              color: "#6B7280",
              border: "1px solid #E4E4E7"
            }}>
              3 Total
            </div>
          </Col>
        </Row>

        {/* Zone Cards */}
        <div className="d-flex flex-column" >
          {zones.map((zone) => (
            <Card key={zone.id} style={getZoneCardStyle(zone.highlighted)}>
              <CardBody className="p-3">
                <Row className="align-items-center">
                  <Col>
                    <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                      <MapPin size={18} color="#3182ce" />
                      <span style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: '#000000'
                      }}>
                        {zone.name}
                      </span>
                    </div>
                  </Col>
                  <Col xs="auto">
                    <div style={getPriorityStyle(zone.priority)}>
                      {zone.priority}
                    </div>
                  </Col>
                </Row>

                <Row className="mt-2 align-items-center">
                  <Col>
                    <span style={{
                      fontSize: '13px',
                      color: '#718096'
                    }}>
                      Cameras: {zone.cameras}
                    </span>
                  </Col>
                  <Col xs="auto">
                    <span style={{
                      fontSize: '13px',
                      color: '#e53e3e',
                      fontWeight: 500
                    }}>
                      {zone.alerts} alerts
                    </span>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        </div>
       
      </CardBody>
    </Card>

  );
}
